module.exports = __webpack_public_path__ + "static/media/Amazon_Web_Services_Logo.svg.d6654315.png";